// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__kd1ba","primary":"button_primary__2JQeP"};